(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_main-product-v2-buy-panel"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('main-product-v2-buy-panel')) {
      customElements.define(
        'main-product-v2-buy-panel',
        class MainProductV2BuyPanel extends HTMLElement {
          connectedCallback() {
            this.bindQuantityChange();
            this.bindRecommendProductChange();
            this.bindAddToCart();
            this.bindCheckout();
          }

          disconnectedCallback() {
            if (this.unsubscribeQuantityChange) {
              this.unsubscribeQuantityChange();
              this.unsubscribeQuantityChange = null;
            }
            if (this.unsubscribeRecommendChange) {
              this.unsubscribeRecommendChange();
              this.unsubscribeRecommendChange = null;
            }
          }

          bindQuantityChange() {
            if (this.unsubscribeQuantityChange || !window.litime?.eventBus) return;

            this.unsubscribeQuantityChange = window.litime.eventBus.subscribe(
              'main-product-v2-quantity:change',
              ({ quantity }) => {
                if (!Number.isFinite(quantity) || quantity <= 0) return;
                this.setAttribute('data-quantity', quantity);
                this.updatePriceDisplay();
              }
            );
          }

          bindRecommendProductChange() {
            if (this.unsubscribeRecommendChange || !window.litime?.eventBus) return;

            this.selectedRecommendProducts = window.litime.mainProductV2RecommendSelectedProducts || [];
            this.unsubscribeRecommendChange = window.litime.eventBus.subscribe(
              'main-product-v2-recommend-product:change',
              ({ selectedProducts }) => {
                this.selectedRecommendProducts = Array.isArray(selectedProducts) ? selectedProducts : [];
                window.litime.mainProductV2RecommendSelectedProducts = this.selectedRecommendProducts;
                this.updatePriceDisplay();
              }
            );
          }

          getRecommendTotals() {
            let price = 0;
            let compare = 0;

            for (const item of this.selectedRecommendProducts || []) {
              const qty = item.quantity || 1;
              const unitPrice = item.price || 0;
              const unitCompare = item.comparePrice || 0;

              price += unitPrice * qty;
              if (unitCompare > unitPrice && unitCompare > 0) {
                compare += unitCompare * qty;
              } else {
                compare += unitPrice * qty;
              }
            }

            return { price, compare };
          }

          getUnitPrice() {
            const price = parseInt(this.getAttribute('data-current-price'), 10);
            return Number.isFinite(price) ? price : 0;
          }

          getUnitComparePrice() {
            const price = parseInt(this.getAttribute('data-compare-price'), 10);
            return Number.isFinite(price) ? price : 0;
          }

          updatePriceDisplay() {
            const quantity = this.getQuantity();
            const unitPrice = this.getUnitPrice();
            const unitComparePrice = this.getUnitComparePrice();
            const recommendTotals = this.getRecommendTotals();
            const totalPrice = unitPrice * quantity + recommendTotals.price;
            const totalComparePrice = unitComparePrice * quantity + recommendTotals.compare;
            const moneyFormat = window.shopMoneyFormat;

            if (!window.Shopify?.formatMoney) return;

            const priceCurrentEl = this.querySelector('.main-product-v2-buy-panel__price-current');
            if (priceCurrentEl) {
              priceCurrentEl.innerHTML = window.Shopify.formatMoney(totalPrice, moneyFormat);
            }

            const priceCompareEl = this.querySelector('.main-product-v2-buy-panel__price-compare');
            const showCompare = totalComparePrice > totalPrice && totalComparePrice > 0;
            if (priceCompareEl) {
              priceCompareEl.setAttribute('data-show', showCompare ? 'true' : 'false');
              if (showCompare) {
                priceCompareEl.innerHTML = window.Shopify.formatMoney(totalComparePrice, moneyFormat);
              }
            }

            const priceDiscountEl = this.querySelector('.main-product-v2-buy-panel__price-discount');
            if (priceDiscountEl) {
              priceDiscountEl.setAttribute('data-show', showCompare ? 'true' : 'false');
            }

            const globalDiscountEl = this.querySelector('.main-product-v2-buy-panel__price-discount global-discount');
            if (globalDiscountEl && totalComparePrice > totalPrice) {
              globalDiscountEl.setAttribute(
                'data-total',
                JSON.stringify({
                  price: totalPrice,
                  compare_price: totalComparePrice,
                })
              );
            }
          }

          getVariantId() {
            return this.getAttribute('data-variant-id');
          }

          getQuantity() {
            const quantity = parseInt(this.getAttribute('data-quantity'), 10);
            return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
          }

          getCartItems() {
            const variantId = parseInt(this.getVariantId(), 10);
            if (!Number.isFinite(variantId)) return [];

            const items = [
              {
                id: variantId,
                quantity: this.getQuantity(),
              },
            ];

            for (const product of this.selectedRecommendProducts || []) {
              const id = parseInt(product.variantId, 10);
              const quantity = parseInt(product.quantity, 10) || 1;
              if (Number.isFinite(id) && id > 0) {
                items.push({ id, quantity });
              }
            }

            return items;
          }

          getCheckoutUrl() {
            const variantId = parseInt(this.getVariantId(), 10);
            if (!Number.isFinite(variantId)) return '/cart';

            const segments = [
              `${variantId}:${this.getQuantity()}`,
              ...(this.selectedRecommendProducts || []).map((product) => {
                const id = parseInt(product.variantId, 10);
                const quantity = parseInt(product.quantity, 10) || 1;
                if (!Number.isFinite(id) || id <= 0) return null;
                return `${id}:${quantity}`;
              }),
            ].filter(Boolean);

            return `/cart/${segments.join(',')}`;
          }

          getButtonEl(actionEl) {
            return actionEl.querySelector('.global-button-v2');
          }

          setButtonLoading(buttonEl, loading) {
            if (!buttonEl) return;
            buttonEl.setAttribute('data-loading', loading ? 'true' : 'false');
          }

          bindAddToCart() {
            const actionEl = this.querySelector('[data-action="add-to-cart"]');
            if (!actionEl || actionEl.dataset.bound === 'true') return;

            actionEl.dataset.bound = 'true';
            actionEl.addEventListener('click', async (e) => {
              e.preventDefault();
              e.stopPropagation();

              const buttonEl = this.getButtonEl(actionEl);
              if (buttonEl?.getAttribute('data-loading') === 'true') return;

              const variantId = this.getVariantId();
              if (!variantId) return;

              const cartItems = this.getCartItems();
              if (!cartItems.length) return;

              try {
                this.setButtonLoading(buttonEl, true);
                await window.litime.addCart(cartItems);
              } catch (error) {
                console.error('[main-product-v2-buy-panel] add to cart error:', error);
              } finally {
                this.setButtonLoading(buttonEl, false);
              }
            });
          }

          bindCheckout() {
            const actionEl = this.querySelector('[data-action="checkout"]');
            if (!actionEl || actionEl.dataset.bound === 'true') return;

            actionEl.dataset.bound = 'true';
            actionEl.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();

              const buttonEl = this.getButtonEl(actionEl);
              if (buttonEl?.getAttribute('data-loading') === 'true') return;

              const variantId = this.getVariantId();
              if (!variantId) return;

              this.setButtonLoading(buttonEl, true);
              window.location.href = this.getCheckoutUrl();
            });
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_main-product-v2-countdown"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('main-product-v2-countdown')) {
      customElements.define(
        'main-product-v2-countdown',
        class MainProductV2Countdown extends HTMLElement {
          constructor() {
            super();
            this._timer = null;
          }

          connectedCallback() {
            this.init();
          }

          disconnectedCallback() {
            if (this._timer) {
              clearInterval(this._timer);
              this._timer = null;
            }
          }

          init() {
            this.updateCountdown();
            this._timer = setInterval(() => this.updateCountdown(), 1000);
          }

          updateCountdown() {
            const $this = $(this);
            const $timeEl = $this.find('[data-ref="time"]');
            if (!$timeEl.length) return;

            let time = String($timeEl.data('time') || '')
              .trim()
              .replace(/\//g, '-');
            const timeFormat = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;

            if (!timeFormat.test(time)) {
              this.hide();
              return;
            }

            const endTime = new Date(time).getTime();
            const diff = endTime - Date.now();

            if (diff <= 0) {
              this.hide(true);
              return;
            }

            this.classList.remove('main-product-v2-countdown--hidden');

            const pad = (n) => String(n).padStart(2, '0');
            const days = Math.floor(diff / 86400000);
            const hours = Math.floor((diff % 86400000) / 3600000);
            const minutes = Math.floor((diff % 3600000) / 60000);
            const seconds = Math.floor((diff % 60000) / 1000);

            this.setUnit($timeEl, 'days', pad(days), 'D');
            this.setUnit($timeEl, 'hours', pad(hours), 'H');
            this.setUnit($timeEl, 'minutes', pad(minutes), 'M');
            this.setUnit($timeEl, 'seconds', pad(seconds), 'S');
          }

          setUnit($timeEl, unit, value, suffix) {
            const $el = $timeEl.find(`[data-unit="${unit}"]`);
            if ($el.length) {
              $el.text(`${value}${suffix}`);
            }
          }

          hide(clearTimer = false) {
            this.classList.add('main-product-v2-countdown--hidden');
            if (clearTimer && this._timer) {
              clearInterval(this._timer);
              this._timer = null;
            }
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_main-product-v2-coupon"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (customElements.get('main-product-v2-coupon')) return;

    customElements.define(
      'main-product-v2-coupon',
      class MainProductV2Coupon extends HTMLElement {
        connectedCallback() {
          this._timer = null;
          this._expiryNotified = false;
          this._runCountdown();
        }

        disconnectedCallback() {
          if (this._timer) {
            clearInterval(this._timer);
            this._timer = null;
          }
        }

        _runCountdown() {
          const timeEl = this.querySelector('.time[data-time]');
          const countdownEl = this.querySelector('[data-ref="countdown"]');
          if (!timeEl) return;

          const endRaw = timeEl.dataset.time;

          if (!endRaw) {
            if (countdownEl) countdownEl.dataset.show = 'false';
            if (this._timer) {
              clearInterval(this._timer);
              this._timer = null;
            }
            return;
          }

          let endTime = parseInt(endRaw, 10);
          if (endTime < 10000000000) endTime *= 1000;

          const diff = endTime - Date.now();

          if (diff <= 0) {
            this._hideComponent(countdownEl);
            return;
          }

          if (countdownEl) countdownEl.dataset.show = 'true';
          this._renderTime(diff, timeEl);

          if (!this._timer) {
            this._timer = setInterval(() => this._runCountdown(), 1000);
          }
        }

        _renderTime(diff, timeEl) {
          const days = Math.floor(diff / 86400000);
          const hours = Math.floor((diff % 86400000) / 3600000);
          const minutes = Math.floor((diff % 3600000) / 60000);
          const seconds = Math.floor((diff % 60000) / 1000);
          const pad = (n) => String(n).padStart(2, '0');

          const setText = (sel, val) => {
            const el = timeEl.querySelector(sel);
            if (el) el.textContent = val;
          };
          setText('.days', pad(days));
          setText('.hrs', pad(hours));
          setText('.min', pad(minutes));
          setText('.sec', pad(seconds));
        }

        _hideComponent(countdownEl) {
          if (countdownEl) countdownEl.dataset.show = 'false';
          this.dataset.show = 'false';
          if (this._timer) {
            clearInterval(this._timer);
            this._timer = null;
          }
          this._notifyExpiry();
        }

        _notifyExpiry() {
          if (this._expiryNotified) return;
          this._expiryNotified = true;
          window.litime?.eventBus?.publish('main-product-v2-coupon:expired');
        }
      }
    );
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_main-product-v2-customer-service"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('main-product-v2-customer-service')) {
      customElements.define(
        'main-product-v2-customer-service',
        class MainProductV2CustomerService extends HTMLElement {
          constructor() {
            super();
          }

          connectedCallback() {
            this.init();
          }

          init() {
            const $trigger = $(this).find('.main-product-v2-customer-service__trigger');
            $trigger.on('click', () => {
              if (window.litime?.openChatApp) {
                window.litime.openChatApp();
              }
            });
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_main-product-v2-multiattribute"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (customElements.get('main-product-v2-multiattribute')) return;

    customElements.define(
      'main-product-v2-multiattribute',
      class MainProductV2Multiattribute extends HTMLElement {
        connectedCallback() {
          this._handleClick = this.handleClick.bind(this);
          this.addEventListener('click', this._handleClick);
          this.bindCouponExpiry();
          this.variantMode = this.dataset.variantMode || 'single';

          if (this.variantMode === 'multi') {
            this.initMultiOptionState();
            this.updateMultiOptionAvailability();
          }
        }

        disconnectedCallback() {
          this.removeEventListener('click', this._handleClick);
          this.unbindCouponExpiry();
        }

        bindCouponExpiry() {
          if (this.unsubscribeCouponExpiry || !window.litime?.eventBus) return;

          this.unsubscribeCouponExpiry = window.litime.eventBus.subscribe('main-product-v2-coupon:expired', () => {
            this.refreshCurrentVariantOnCouponExpiry();
          });
        }

        unbindCouponExpiry() {
          if (this.unsubscribeCouponExpiry) {
            this.unsubscribeCouponExpiry();
            this.unsubscribeCouponExpiry = null;
          }
        }

        refreshCurrentVariantOnCouponExpiry() {
          if (this.variantMode === 'multi') {
            const variant = this.findVariantByOptions(this.selectedOptions);
            if (variant) this.switchVariantWithPayload(variant, { resetPriceToOriginal: true });
            return;
          }

          const activeItem = this.querySelector('.main-product-v2-multiattribute__item[data-active="true"]');
          if (!activeItem) return;

          const payload = this.getVariantPayloadFromElement(activeItem);
          payload.displayPrice = payload.originalPrice;
          payload.couponEndAt = '';
          payload.couponTitle = '';
          this.switchVariantWithPayload(payload);
        }

        handleClick(event) {
          if (this.variantMode === 'multi') {
            const chip = event.target.closest('.main-product-v2-multiattribute__chip');
            if (!chip || !this.contains(chip)) return;
            if (chip.getAttribute('data-active') === 'true') return;
            this.handleChipClick(chip);
            return;
          }

          const item = event.target.closest('.main-product-v2-multiattribute__item');
          if (!item || !this.contains(item)) return;
          if (item.getAttribute('data-active') === 'true') return;

          this.querySelectorAll('.main-product-v2-multiattribute__item').forEach((el) => {
            el.setAttribute('data-active', el === item ? 'true' : 'false');
          });

          this.switchVariantWithPayload(this.getVariantPayloadFromElement(item));
        }

        initMultiOptionState() {
          this.variantSources = Array.from(
            this.querySelectorAll('.main-product-v2-multiattribute__variant-source')
          ).map((el) => this.getVariantPayloadFromElement(el));

          this.selectedOptions = Array.from(this.querySelectorAll('.main-product-v2-multiattribute__group')).map(
            (group) => {
              const activeChip = group.querySelector('.main-product-v2-multiattribute__chip[data-active="true"]');
              return activeChip?.getAttribute('data-value') || '';
            }
          );
        }

        handleChipClick(chip) {
          const optionIndex = Number(chip.getAttribute('data-option-index'));
          const value = chip.getAttribute('data-value');
          if (!Number.isFinite(optionIndex) || !value) return;

          const nextSelected = [...this.selectedOptions];
          nextSelected[optionIndex] = value;

          let matched = this.findVariantByOptions(nextSelected);
          if (!matched) {
            matched = this.findBestVariantForOption(optionIndex, value, nextSelected);
          }
          if (!matched) return;

          this.selectedOptions = matched.options.slice(0, this.selectedOptions.length);

          this.querySelectorAll('.main-product-v2-multiattribute__group').forEach((group, index) => {
            group.querySelectorAll('.main-product-v2-multiattribute__chip').forEach((el) => {
              el.setAttribute(
                'data-active',
                el.getAttribute('data-value') === this.selectedOptions[index] ? 'true' : 'false'
              );
            });
          });

          this.updateMultiOptionAvailability();
          this.switchVariantWithPayload(matched);
        }

        getVariantPayloadFromElement(el) {
          const inventoryQuantity = parseInt(el.dataset.inventoryQuantity, 10) || 0;
          const rawInventoryQuantity = parseInt(el.dataset.rawInventoryQuantity, 10);
          const parsedRawInventoryQuantity = Number.isFinite(rawInventoryQuantity) ? rawInventoryQuantity : 0;
          let options = [];

          try {
            options = JSON.parse(el.dataset.options || '[]');
          } catch (error) {
            options = [];
          }

          return {
            variantId: el.dataset.variantId,
            displayPrice: parseInt(el.dataset.displayPrice, 10) || 0,
            originalPrice: parseInt(el.dataset.originalPrice, 10) || 0,
            originalComparePrice: parseInt(el.dataset.originalComparePrice, 10) || 0,
            comparePrice: parseInt(el.dataset.comparePrice, 10) || 0,
            couponEndAt: el.dataset.couponEnd || '',
            couponTitle: el.dataset.couponTitle || '',
            inventoryPolicy: el.dataset.inventoryPolicy || 'deny',
            inventoryQuantity,
            rawInventoryQuantity: parsedRawInventoryQuantity,
            taxExempt: el.dataset.taxExempt === 'true',
            stockout: el.dataset.stockout === 'true',
            featuredImagePosition: parseInt(el.dataset.featuredImagePosition, 10) || 1,
            options,
          };
        }

        isVariantUnavailable(variant) {
          if (!variant) return true;
          if (variant.stockout) return true;
          if (variant.inventoryPolicy === 'deny' && Number(variant.rawInventoryQuantity) <= 0) return true;
          return false;
        }

        findVariantByOptions(selectedOptions) {
          return (
            this.variantSources.find((variant) => {
              return selectedOptions.every((value, index) => {
                if (value == null || value === '') return true;
                return variant.options[index] === value;
              });
            }) || null
          );
        }

        findBestVariantForOption(optionIndex, value, selectedOptions) {
          const candidates = this.variantSources.filter((variant) => variant.options[optionIndex] === value);
          if (!candidates.length) return null;

          let best = null;
          let bestScore = -1;

          candidates.forEach((variant) => {
            let score = 0;
            selectedOptions.forEach((selectedValue, index) => {
              if (index === optionIndex) return;
              if (selectedValue && variant.options[index] === selectedValue) score += 1;
            });
            if (!this.isVariantUnavailable(variant)) score += 10;
            if (score > bestScore) {
              bestScore = score;
              best = variant;
            }
          });

          return best;
        }

        /**
         * 判断某个规格值在「它自身 + 前序已选规格」下是否还有可购买的 variant
         * 用于已选中的规格值：避免后面规格缺货时，把前面的选中项一起置灰
         */
        hasAvailableVariantForPrefix(optionIndex, value) {
          return this.variantSources.some((variant) => {
            if (variant.options[optionIndex] !== value) return false;

            for (let index = 0; index < optionIndex; index += 1) {
              const selectedValue = this.selectedOptions[index];
              if (selectedValue && variant.options[index] !== selectedValue) return false;
            }

            return !this.isVariantUnavailable(variant);
          });
        }

        updateMultiOptionAvailability() {
          const chips = this.querySelectorAll('.main-product-v2-multiattribute__chip');
          chips.forEach((chip) => {
            const optionIndex = Number(chip.getAttribute('data-option-index'));
            const value = chip.getAttribute('data-value');
            let unavailable;

            if (chip.getAttribute('data-active') === 'true') {
              unavailable = !this.hasAvailableVariantForPrefix(optionIndex, value);
            } else {
              const nextSelected = [...this.selectedOptions];
              nextSelected[optionIndex] = value;
              unavailable = this.isVariantUnavailable(this.findVariantByOptions(nextSelected));
            }

            chip.setAttribute('data-unavailable', unavailable ? 'true' : 'false');
          });
        }

        switchVariantWithPayload(payload, options = {}) {
          if (!payload?.variantId) return;

          if (options.resetPriceToOriginal) {
            payload = {
              ...payload,
              displayPrice: payload.originalPrice,
              couponEndAt: '',
              couponTitle: '',
            };
          }

          this.updateURL(payload.variantId);
          this.applyVariantToPage(payload);
          this.syncPackageVariantTab(payload.variantId);
          window.litime?.eventBus?.publish('main-product-v2-variant:change', payload);
        }

        updateURL(variantId) {
          const currentUrl = this.dataset.url;
          if (!currentUrl || !variantId) return;
          window.history.replaceState({}, '', `${currentUrl}?variant=${variantId}`);
        }

        applyVariantToPage(payload) {
          this.updatePriceBlock(payload);
          this.updateCouponBlock(payload);
          this.updateQuantityBlock(payload);
          this.updateBuyPanel(payload);
          this.updateBar(payload);
          this.updateGallery(payload);
          this.resetRecommendProducts();
        }

        updatePriceBlock(payload) {
          const priceBlock = document.querySelector('main-product-v2-price');
          if (!priceBlock || !window.Shopify?.formatMoney) return;

          const moneyFormat = window.shopMoneyFormat;
          const displayPrice = payload.displayPrice;
          const comparePrice = payload.comparePrice;
          const showCompare = comparePrice > displayPrice && comparePrice > 0;

          const container = priceBlock.querySelector('.main-product-v2-price__container');
          if (container) {
            container.dataset.currentPrice = displayPrice;
            container.dataset.comparePrice = comparePrice;
          }

          const currentEl = priceBlock.querySelector('.current_price');
          if (currentEl) {
            currentEl.innerHTML = window.Shopify.formatMoney(displayPrice, moneyFormat);
          }

          const compareEl = priceBlock.querySelector('.current_compare_at_price');
          if (compareEl) {
            if (showCompare) {
              compareEl.innerHTML = window.Shopify.formatMoney(comparePrice, moneyFormat);
              compareEl.style.display = '';
            } else {
              compareEl.innerHTML = '';
              compareEl.style.display = 'none';
            }
          }

          const discountEl = priceBlock.querySelector('.main-product-v2-price__discount');
          if (discountEl) {
            discountEl.style.display = showCompare ? '' : 'none';
          }

          const globalDiscountEl = priceBlock.querySelector('.main-product-v2-price__discount global-discount');
          if (globalDiscountEl && showCompare) {
            globalDiscountEl.setAttribute(
              'data-total',
              JSON.stringify({
                price: displayPrice,
                compare_price: comparePrice,
              })
            );
          }
        }

        updateCouponBlock(payload) {
          const couponEl = document.querySelector('main-product-v2-coupon');
          if (!couponEl) return;

          const showCoupon = Boolean(payload.couponTitle);
          couponEl.dataset.show = showCoupon ? 'true' : 'false';

          const titleEl = couponEl.querySelector('.main-product-v2-coupon__title');
          if (titleEl) titleEl.textContent = payload.couponTitle || '';

          const countdownEl = couponEl.querySelector('[data-ref="countdown"]');
          const timeEl = couponEl.querySelector('.time[data-time]');
          if (timeEl) timeEl.dataset.time = payload.couponEndAt || '';

          if (typeof couponEl._runCountdown === 'function') {
            couponEl._expiryNotified = false;
            if (couponEl._timer) {
              clearInterval(couponEl._timer);
              couponEl._timer = null;
            }
            if (showCoupon && payload.couponEndAt) {
              couponEl._runCountdown();
            } else if (countdownEl) {
              countdownEl.dataset.show = 'false';
            }
          }
        }

        updateQuantityBlock(payload) {
          const quantityEl = document.querySelector('main-product-v2-quantity');
          if (!quantityEl) return;

          let max = 999;
          let plusDisabled = false;

          if (payload.inventoryPolicy === 'deny') {
            if (payload.inventoryQuantity > 0) {
              max = Math.min(payload.inventoryQuantity, 999);
            } else {
              max = 1;
              plusDisabled = true;
            }
          }

          quantityEl.setAttribute('data-max', max);

          if (typeof quantityEl.setQuantity === 'function') {
            quantityEl.setQuantity(1);
          } else {
            window.litime?.eventBus?.publish('main-product-v2-quantity:change', { quantity: 1 });
          }

          const inputRoot = quantityEl.querySelector('.global-number-input-v2');
          if (inputRoot) {
            inputRoot.setAttribute('data-plus-disabled', plusDisabled ? 'true' : 'false');
          }

          if (window.litime) {
            window.litime.mainProductV2RecommendSelectedProducts = [];
          }
          window.litime?.eventBus?.publish('main-product-v2-recommend-product:change', {
            selectedProducts: [],
          });
        }

        updateBuyPanel(payload) {
          const buyPanel = document.querySelector('main-product-v2-buy-panel');
          if (!buyPanel) return;

          buyPanel.setAttribute('data-variant-id', payload.variantId);
          buyPanel.setAttribute('data-current-price', payload.displayPrice);
          buyPanel.setAttribute('data-compare-price', payload.comparePrice);
          buyPanel.setAttribute('data-inventory-policy', payload.inventoryPolicy);

          const klarna = buyPanel.querySelector('klarna-placement');
          if (klarna) klarna.setAttribute('data-purchase-amount', payload.originalPrice);

          this.syncPurchaseButtons(buyPanel, payload);

          if (typeof buyPanel.updatePriceDisplay === 'function') {
            buyPanel.setAttribute('data-quantity', '1');
            buyPanel.updatePriceDisplay();
          }
        }

        updateBar(payload) {
          const bar = document.querySelector('main-product-v2-bar');
          if (!bar) return;

          bar.setAttribute('data-variant-id', payload.variantId);
          bar.setAttribute('data-current-price', payload.displayPrice);
          bar.setAttribute('data-compare-price', payload.comparePrice);
          bar.setAttribute('data-inventory-policy', payload.inventoryPolicy);

          this.syncPurchaseButtons(bar, payload);

          if (typeof bar.updatePriceDisplay === 'function') {
            bar.setAttribute('data-quantity', '1');
            bar.updatePriceDisplay();
          }
        }

        /**
         * 同步购买按钮 / 到货通知，以及库存为 0 + continue 时的 Pre-order 文案
         */
        syncPurchaseButtons(root, payload) {
          if (!root || !payload) return;

          const rawInventoryQuantity = Number.isFinite(payload.rawInventoryQuantity)
            ? payload.rawInventoryQuantity
            : payload.inventoryQuantity;
          const canPurchase =
            rawInventoryQuantity > 0 || (payload.inventoryPolicy === 'continue' && rawInventoryQuantity <= 0);
          const hideBuyNow = rawInventoryQuantity <= 0 && payload.inventoryPolicy === 'continue';

          const buttonsEl =
            root.querySelector('.main-product-v2-buy-panel__buttons') ||
            root.querySelector('.main-product-v2-bar__buttons');
          if (buttonsEl) {
            buttonsEl.setAttribute('data-show', canPurchase ? 'true' : 'false');
          }

          const notifyEl = root.querySelector('.global-notify-me-trigger');
          if (notifyEl) {
            notifyEl.setAttribute('data-show', canPurchase ? 'false' : 'true');
            notifyEl.setAttribute('data-variant', payload.variantId);
          }

          const checkoutAction = root.querySelector('[data-action="checkout"]');
          if (checkoutAction) {
            if (payload.taxExempt) {
              checkoutAction.setAttribute('data-tax-type', 'productDetail');
            } else {
              checkoutAction.removeAttribute('data-tax-type');
            }

            const textEl = checkoutAction.querySelector('.global-button-v2__text');
            if (textEl) {
              textEl.textContent = hideBuyNow
                ? root.dataset.preOrderText || textEl.textContent
                : root.dataset.buyNowText || textEl.textContent;
            }
          }
        }

        updateGallery(payload) {
          const gallery = document.querySelector('main-product-v2-gallery');
          if (!gallery || typeof gallery.goToSlide !== 'function') return;
          gallery.switchTab?.('image');
          gallery.goToSlide((payload.featuredImagePosition || 1) - 1);
        }

        resetRecommendProducts() {
          document.querySelectorAll('main-product-v2-recommend-product-item').forEach((item) => {
            item.setAttribute('data-active', 'false');
            item.setAttribute('data-expand', 'false');
            item.setAttribute('data-quantity', '1');

            const input = item.querySelector('[data-action="input"]');
            const inputRoot = item.querySelector('.global-number-input-v2');

            if (input) input.value = '1';
            if (inputRoot) {
              inputRoot.setAttribute('data-minus-disabled', 'true');
              const max = parseInt(item.getAttribute('data-max'), 10) || 999;
              inputRoot.setAttribute('data-plus-disabled', max <= 1 ? 'true' : 'false');
            }

            if (typeof item.syncItemState === 'function') {
              item.syncItemState();
            }
          });
        }

        syncPackageVariantTab(variantId) {
          if (!variantId) return;

          document.dispatchEvent(
            new CustomEvent('product-variant:change', {
              detail: { variantId: String(variantId) },
              bubbles: true,
            })
          );

          document.querySelectorAll('product-adsorption-package-content').forEach((packageContent) => {
            if (typeof packageContent.activateVariant === 'function') {
              packageContent.activateVariant(String(variantId));
              return;
            }

            const tab = packageContent.querySelector(
              `.product-adsorption-package-content__variant-tab[data-variant-id="${variantId}"]`
            );
            tab?.click();
          });
        }
      }
    );
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_main-product-v2-quantity"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('main-product-v2-quantity')) {
      customElements.define(
        'main-product-v2-quantity',
        class MainProductV2Quantity extends HTMLElement {
          connectedCallback() {
            this.inputRoot = this.querySelector('.global-number-input-v2');
            this.input = this.querySelector('[data-action="input"]');
            this.minusBtn = this.querySelector('[data-action="minus"]');
            this.plusBtn = this.querySelector('[data-action="plus"]');

            if (!this.inputRoot || !this.input) return;

            this.bindMinus();
            this.bindPlus();
            this.bindInput();
            this.setQuantity(this.parseQuantity(this.input.value));
          }

          getMin() {
            const min = parseInt(this.getAttribute('data-min'), 10);
            return Number.isFinite(min) && min > 0 ? min : 1;
          }

          getMax() {
            const max = parseInt(this.getAttribute('data-max'), 10);
            return Number.isFinite(max) && max > 0 ? max : 999;
          }

          parseQuantity(value) {
            const quantity = parseInt(String(value).replace(/[^\d]/g, ''), 10);
            return Number.isFinite(quantity) ? quantity : this.getMin();
          }

          clampQuantity(value) {
            return Math.min(Math.max(value, this.getMin()), this.getMax());
          }

          updateDisabledState(value) {
            this.inputRoot.setAttribute('data-minus-disabled', value <= this.getMin() ? 'true' : 'false');
            this.inputRoot.setAttribute('data-plus-disabled', value >= this.getMax() ? 'true' : 'false');
          }

          setQuantity(value) {
            const next = this.clampQuantity(value);
            this.input.value = String(next);
            this.updateDisabledState(next);
            this.syncQuantity(next);
            return next;
          }

          syncQuantity(quantity) {
            this.setAttribute('data-value', quantity);
            window.litime?.eventBus?.publish('main-product-v2-quantity:change', { quantity });
          }

          bindMinus() {
            if (!this.minusBtn || this.minusBtn.dataset.bound === 'true') return;

            this.minusBtn.dataset.bound = 'true';
            this.minusBtn.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();

              if (this.inputRoot.getAttribute('data-minus-disabled') === 'true') return;

              this.setQuantity(this.parseQuantity(this.input.value) - 1);
            });
          }

          bindPlus() {
            if (!this.plusBtn || this.plusBtn.dataset.bound === 'true') return;

            this.plusBtn.dataset.bound = 'true';
            this.plusBtn.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();

              if (this.inputRoot.getAttribute('data-plus-disabled') === 'true') return;

              this.setQuantity(this.parseQuantity(this.input.value) + 1);
            });
          }

          bindInput() {
            if (!this.input || this.input.dataset.bound === 'true') return;

            this.input.dataset.bound = 'true';

            this.input.addEventListener('input', () => {
              const sanitized = this.input.value.replace(/[^\d]/g, '');
              const max = this.getMax();

              if (sanitized === '') {
                this.input.value = '';
                return;
              }

              const next = parseInt(sanitized, 10);
              this.input.value = String(next > max ? max : next);
              this.updateDisabledState(this.parseQuantity(this.input.value));
            });

            this.input.addEventListener('blur', () => {
              if (this.input.value === '') {
                this.setQuantity(this.getMin());
                return;
              }

              this.setQuantity(this.parseQuantity(this.input.value));
            });
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_main-product-v2-recommend-product"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('main-product-v2-recommend-product-item')) {
      customElements.define(
        'main-product-v2-recommend-product-item',
        class MainProductV2RecommendProductItem extends HTMLElement {
          connectedCallback() {
            this.card = this.querySelector('.main-product-v2-recommend-product-item');
            this._handleClick = this.handleClick.bind(this);
            this.addEventListener('click', this._handleClick);
            this.initQuantity();
            this.syncItemState();
            this._ready = true;
          }

          disconnectedCallback() {
            this.removeEventListener('click', this._handleClick);
          }

          handleClick(event) {
            if (!this.card) return;

            if (event.target.closest('.main-product-v2-recommend-product-item__expand-toggle')) {
              event.preventDefault();
              event.stopPropagation();
              const isExpanded = this.getAttribute('data-expand') === 'true';
              this.setAttribute('data-expand', isExpanded ? 'false' : 'true');
              return;
            }

            if (event.target.closest('.global-number-input-v2')) return;
            if (event.target.closest('a')) return;

            if (this.card.contains(event.target)) {
              event.preventDefault();
              this.toggleActive();
            }
          }

          toggleActive() {
            const isActive = this.getAttribute('data-active') === 'true';
            this.setAttribute('data-active', isActive ? 'false' : 'true');
            this.notifyChange();
          }

          getItemData() {
            return {
              variantId: this.dataset.variantId,
              price: parseInt(this.dataset.price, 10) || 0,
              comparePrice: parseInt(this.dataset.comparePrice, 10) || 0,
              quantity: parseInt(this.getAttribute('data-quantity'), 10) || 1,
            };
          }

          syncItemState() {
            const quantity = parseInt(this.getAttribute('data-quantity'), 10) || 1;
            const active = this.getAttribute('data-active') === 'true';

            this.setAttribute('data-quantity', String(quantity));
            this.setAttribute('data-active', active ? 'true' : 'false');
            this.setAttribute('data-item', JSON.stringify(this.getItemData()));
          }

          notifyChange() {
            this.syncItemState();
            this.dispatchEvent(
              new CustomEvent('main-product-v2-recommend-product-item:change', {
                bubbles: true,
                detail: this.getItemData(),
              })
            );
          }

          initQuantity() {
            const inputRoot = this.querySelector('.global-number-input-v2');
            const input = this.querySelector('[data-action="input"]');
            const minusBtn = this.querySelector('[data-action="minus"]');
            const plusBtn = this.querySelector('[data-action="plus"]');

            if (!inputRoot || !input || input.dataset.bound === 'true') return;

            input.dataset.bound = 'true';

            const getMin = () => {
              const min = parseInt(this.getAttribute('data-min'), 10);
              return Number.isFinite(min) && min > 0 ? min : 1;
            };

            const getMax = () => {
              const max = parseInt(this.getAttribute('data-max'), 10);
              return Number.isFinite(max) && max > 0 ? max : 999;
            };

            const parseQuantity = (value) => {
              const quantity = parseInt(String(value).replace(/[^\d]/g, ''), 10);
              return Number.isFinite(quantity) ? quantity : getMin();
            };

            const updateDisabledState = (value) => {
              inputRoot.setAttribute('data-minus-disabled', value <= getMin() ? 'true' : 'false');
              inputRoot.setAttribute('data-plus-disabled', value >= getMax() ? 'true' : 'false');
            };

            const setQuantity = (value, silent = false) => {
              const next = Math.min(Math.max(value, getMin()), getMax());
              input.value = String(next);
              this.setAttribute('data-quantity', String(next));
              updateDisabledState(next);
              if (!silent && this._ready) this.notifyChange();
              return next;
            };

            setQuantity(parseQuantity(input.value), true);

            minusBtn?.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();
              if (inputRoot.getAttribute('data-minus-disabled') === 'true') return;
              setQuantity(parseQuantity(input.value) - 1);
            });

            plusBtn?.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();
              if (inputRoot.getAttribute('data-plus-disabled') === 'true') return;
              setQuantity(parseQuantity(input.value) + 1);
            });

            input.addEventListener('click', (e) => {
              e.stopPropagation();
            });

            input.addEventListener('input', () => {
              const sanitized = input.value.replace(/[^\d]/g, '');
              const max = getMax();

              if (sanitized === '') {
                input.value = '';
                return;
              }

              const next = parseInt(sanitized, 10);
              input.value = String(next > max ? max : next);
              updateDisabledState(parseQuantity(input.value));
            });

            input.addEventListener('blur', () => {
              if (input.value === '') {
                setQuantity(getMin());
                return;
              }

              setQuantity(parseQuantity(input.value));
            });
          }
        }
      );
    }

    if (!customElements.get('main-product-v2-recommend-product')) {
      customElements.define(
        'main-product-v2-recommend-product',
        class MainProductV2RecommendProduct extends HTMLElement {
          connectedCallback() {
            this.wrapper = this.querySelector('.main-product-v2-recommend-product__content');
            this.selectedProducts = [];
            this._handleItemChange = this.handleItemChange.bind(this);
            this.addEventListener('main-product-v2-recommend-product-item:change', this._handleItemChange);

            const url = this.dataset.url;

            if (url && this.wrapper) {
              this.loadRecommendations(url);
            }
          }

          disconnectedCallback() {
            this.removeEventListener('main-product-v2-recommend-product-item:change', this._handleItemChange);
          }

          handleItemChange() {
            this.selectedProducts = this.collectSelectedProducts();

            if (window.litime) {
              window.litime.mainProductV2RecommendSelectedProducts = this.selectedProducts;
            }

            window.litime?.eventBus?.publish('main-product-v2-recommend-product:change', {
              selectedProducts: this.selectedProducts,
            });
          }

          collectSelectedProducts() {
            return [...this.querySelectorAll('main-product-v2-recommend-product-item')]
              .filter((item) => item.getAttribute('data-active') === 'true')
              .map((item) => item.getItemData());
          }

          async loadRecommendations(url) {
            try {
              const response = await fetch(url);
              const text = await response.text();
              const parser = new DOMParser();
              const doc = parser.parseFromString(text, 'text/html');
              const recommendationsContainer = doc.querySelector('.main-product-v2-recommend-product__content');

              if (recommendationsContainer?.innerHTML.trim()) {
                this.wrapper.innerHTML = recommendationsContainer.innerHTML;
              }
            } catch (error) {
              console.error('[main-product-v2-recommend-product] Failed to load recommendations:', error);
            }
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_main-product-v2-vip"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (customElements.get('main-product-v2-vip')) return;

    customElements.define(
      'main-product-v2-vip',
      class MainProductV2Vip extends HTMLElement {
        connectedCallback() {
          this.querySelector('[data-action="login"]')?.addEventListener('click', () => {
            window.litime?.eventBus?.publish('LOGIN');
          });

          this.querySelector('[data-action="register"]')?.addEventListener('click', () => {
            window.litime?.eventBus?.publish('REGISTER');
          });
        }
      }
    );
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-tabs-content-v2-faq"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('product-adsorption-faq-content')) {
      customElements.define(
        'product-adsorption-faq-content',
        class ProductAdsorptionFaqContent extends HTMLElement {
          connectedCallback() {
            this._handleClick = this.handleClick.bind(this);
            this.addEventListener('click', this._handleClick);
          }

          disconnectedCallback() {
            this.removeEventListener('click', this._handleClick);
          }

          get isAccordion() {
            return this.dataset.isAccordion === 'true';
          }

          handleClick(event) {
            const item = event.target.closest('.product-adsorption-faq-content__item');
            if (!item || !this.contains(item)) return;

            const isActive = item.getAttribute('data-active') === 'true';

            if (this.isAccordion && !isActive) {
              this.querySelectorAll('.product-adsorption-faq-content__item[data-active="true"]').forEach((openItem) => {
                openItem.setAttribute('data-active', 'false');
              });
            }

            item.setAttribute('data-active', isActive ? 'false' : 'true');
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-tabs-content-v2-feature"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('product-features')) {
      customElements.define(
        'product-features',
        class ProductFeatures extends HTMLElement {
          connectedCallback() {
            const container = this.querySelector('.product-features-lazy');
            if (!container) return;

            const observer = new IntersectionObserver((entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  const images = entry.target.querySelectorAll('img');
                  images.forEach((img) => {
                    if (img.dataset.src) {
                      img.src = img.dataset.src;
                      img.removeAttribute('data-src');
                    }
                  });
                  observer.unobserve(entry.target);
                }
              });
            });

            observer.observe(container);
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-tabs-content-v2-navigation"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('product-tabs-content-v2-navigation')) {
      customElements.define(
        'product-tabs-content-v2-navigation',
        class ProductTabsContentV2Navigation extends HTMLElement {
          static DESKTOP_QUERY = '(min-width: 1201px)';
          static STICKY_TOP = 120;
          static NAV_ITEM_HEIGHT = 22;
          static NAV_ITEM_GAP = 16;
          static SCROLL_LOCK_MS = 800;

          connectedCallback() {
            this.reviewRoot = this.closest('product-adsorption-review-content');
            this.reviewContainer = this.reviewRoot
              ? this.reviewRoot.querySelector('.product-adsorption-review-content__container')
              : null;
            this.railActive = this.querySelector('.product-adsorption-review-content__nav-rail-active');
            this.links = Array.from(
              this.querySelectorAll('.product-adsorption-review-content__nav-link[data-nav-anchor]')
            );
            this.desktopMedia = window.matchMedia(ProductTabsContentV2Navigation.DESKTOP_QUERY);
            this._isNavigating = false;
            this._scrollLockLink = null;
            this._positionRaf = null;

            if (!this.reviewRoot || !this.links.length) return;

            this._onScroll = () => {
              this._schedulePositionUpdate();
              this._updateActiveLink();
            };
            this._onResize = () => this._updatePosition();
            this._onDesktopChange = () => this._updatePosition();
            this._onClick = (event) => this._handleClick(event);
            this._onKeydown = (event) => this._handleKeydown(event);

            this.links.forEach((link) => {
              link.addEventListener('click', this._onClick);
              link.addEventListener('keydown', this._onKeydown);
            });

            window.addEventListener('scroll', this._onScroll, { passive: true });
            window.addEventListener('resize', this._onResize);
            this.desktopMedia.addEventListener('change', this._onDesktopChange);

            this._panelObserver = new MutationObserver(() => this._updatePosition());
            this._panelObserver.observe(this.reviewRoot, {
              attributes: true,
              attributeFilter: ['class', 'aria-hidden'],
            });

            this._updatePosition();
            this._updateActiveLink();
          }

          disconnectedCallback() {
            window.removeEventListener('scroll', this._onScroll);
            window.removeEventListener('resize', this._onResize);
            this.desktopMedia.removeEventListener('change', this._onDesktopChange);
            this._panelObserver?.disconnect();
            if (this._positionRaf) {
              cancelAnimationFrame(this._positionRaf);
            }
            clearTimeout(this._scrollUnlockTimer);
            this.links?.forEach((link) => {
              link.removeEventListener('click', this._onClick);
              link.removeEventListener('keydown', this._onKeydown);
            });
          }

          _schedulePositionUpdate() {
            if (this._positionRaf) return;

            this._positionRaf = requestAnimationFrame(() => {
              this._positionRaf = null;
              this._updatePosition();
            });
          }

          _getOffsets() {
            const styles = getComputedStyle(this);

            return {
              x: Number.parseFloat(styles.getPropertyValue('--review-nav-offset-x')) || 0,
              y: Number.parseFloat(styles.getPropertyValue('--review-nav-offset-y')) || 0,
            };
          }

          _applyPosition(left, top) {
            const nextLeft = `${left}px`;
            const nextTop = `${top}px`;

            if (this.style.left !== nextLeft) {
              this.style.left = nextLeft;
            }

            if (this.style.top !== nextTop) {
              this.style.top = nextTop;
            }
          }

          _isReviewPanelActive() {
            return (
              this.reviewRoot.classList.contains('product-tabs-content-v2__panel--active') &&
              this.reviewRoot.getAttribute('aria-hidden') !== 'true'
            );
          }

          /** 基于 product-adsorption-review-content__container + --review-nav-offset-x/y 定位 */
          _updatePosition() {
            if (!this.desktopMedia.matches || !this._isReviewPanelActive()) {
              this.classList.remove('is-visible');
              return;
            }

            const containerRect = this.reviewContainer
              ? this.reviewContainer.getBoundingClientRect()
              : this.reviewRoot.getBoundingClientRect();
            const stickyTop = ProductTabsContentV2Navigation.STICKY_TOP;
            const navHeight = this.offsetHeight;
            const { x: offsetX, y: offsetY } = this._getOffsets();

            if (containerRect.bottom <= stickyTop || containerRect.top >= window.innerHeight) {
              this.classList.remove('is-visible');
              return;
            }

            const left = containerRect.left + offsetX;
            let top = stickyTop + offsetY;

            if (!this._isNavigating) {
              const naturalTop = containerRect.top + offsetY;
              if (naturalTop > stickyTop) {
                top = naturalTop;
              }
            }

            const maxTop = containerRect.bottom - navHeight - 20;
            if (top > maxTop) {
              top = maxTop;
            }

            this._applyPosition(left, top);
            this.classList.add('is-visible');
          }

          _getAnchorElements() {
            return this.links
              .map((link) => {
                const anchorId = link.dataset.navAnchor;
                const target = anchorId ? document.getElementById(anchorId) : null;
                return target ? { link, target } : null;
              })
              .filter(Boolean);
          }

          _setActiveLink(activeLink) {
            if (!activeLink) return;

            const activeIndex = this.links.indexOf(activeLink);

            this.links.forEach((link, index) => {
              const isActive = index === activeIndex;
              link.classList.toggle('adsorption_active-v2', isActive);
              link.classList.remove('adsorption_active');
              link.setAttribute('aria-current', isActive ? 'true' : 'false');
            });

            this._updateRail(activeIndex);
          }

          _updateRail(activeIndex) {
            if (!this.railActive || activeIndex < 0) return;

            const offset =
              activeIndex *
              (ProductTabsContentV2Navigation.NAV_ITEM_HEIGHT + ProductTabsContentV2Navigation.NAV_ITEM_GAP);

            this.railActive.style.transform = `translateY(${offset}px)`;
          }

          _updateActiveLink() {
            if (!this.classList.contains('is-visible')) return;

            if (this._isNavigating && this._scrollLockLink) {
              this._setActiveLink(this._scrollLockLink);
              return;
            }

            const anchors = this._getAnchorElements();
            if (!anchors.length) return;

            const offset = ProductTabsContentV2Navigation.STICKY_TOP + 40;
            let activeEntry = anchors[0];

            anchors.forEach((entry) => {
              const top = entry.target.getBoundingClientRect().top;
              if (top - offset <= 0) {
                activeEntry = entry;
              }
            });

            this._setActiveLink(activeEntry.link);
          }

          _handleClick(event) {
            this._navigateToLink(event.currentTarget, event);
          }

          _handleKeydown(event) {
            if (event.key !== 'Enter' && event.key !== ' ') return;
            this._navigateToLink(event.currentTarget, event);
          }

          _navigateToLink(link, event) {
            const anchorId = link.dataset.navAnchor;
            const target = anchorId ? document.getElementById(anchorId) : null;

            if (!target) return;

            event.preventDefault();

            const top = target.getBoundingClientRect().top + window.scrollY - ProductTabsContentV2Navigation.STICKY_TOP;
            const { x: offsetX, y: offsetY } = this._getOffsets();
            const containerRect = this.reviewContainer
              ? this.reviewContainer.getBoundingClientRect()
              : this.reviewRoot.getBoundingClientRect();

            this._isNavigating = true;
            this._scrollLockLink = link;
            this._setActiveLink(link);
            this._applyPosition(containerRect.left + offsetX, ProductTabsContentV2Navigation.STICKY_TOP + offsetY);

            window.scrollTo({
              top,
              behavior: 'smooth',
            });

            clearTimeout(this._scrollUnlockTimer);
            this._scrollUnlockTimer = setTimeout(() => {
              this._isNavigating = false;
              this._scrollLockLink = null;
              this._updateActiveLink();
            }, ProductTabsContentV2Navigation.SCROLL_LOCK_MS);
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-tabs-content-v2-package"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('product-adsorption-package-content')) {
      customElements.define(
        'product-adsorption-package-content',
        class ProductAdsorptionPackageContent extends HTMLElement {
          static DESKTOP_QUERY = '(min-width: 1201px)';

          connectedCallback() {
            this.variantNav = this.querySelector('.product-adsorption-package-content__variant-nav');
            this.variantTabs = Array.from(this.querySelectorAll('.product-adsorption-package-content__variant-tab'));
            this.accordionItems = Array.from(
              this.querySelectorAll('.product-adsorption-package-content__accordion-item')
            );
            this.desktopMedia = window.matchMedia(ProductAdsorptionPackageContent.DESKTOP_QUERY);

            this._handleTabClick = this.handleTabClick.bind(this);
            this._handleAccordionClick = this.handleAccordionClick.bind(this);
            this._handleAccordionKeydown = this.handleAccordionKeydown.bind(this);
            this._onMobileWheel = this.handleMobileWheel.bind(this);

            this.variantTabs.forEach((tab) => {
              tab.addEventListener('click', this._handleTabClick);
            });

            this.addEventListener('click', this._handleAccordionClick);
            this.addEventListener('keydown', this._handleAccordionKeydown);

            this._onSkuClick = this.handleExternalVariantChange.bind(this);
            this._onVariantChange = this.handleVariantChangeEvent.bind(this);
            this._onResize = this.handleResize.bind(this);
            this._onDesktopChange = this.handleDesktopChange.bind(this);

            document.addEventListener('click', this._onSkuClick, true);
            document.addEventListener('product-variant:change', this._onVariantChange);
            window.addEventListener('resize', this._onResize);
            this.desktopMedia.addEventListener('change', this._onDesktopChange);

            this._panelObserver = new MutationObserver(this.handlePanelVisibility.bind(this));
            const adsorptionPanel = this.closest('.product-tabs-content-v2__panel');
            if (adsorptionPanel) {
              this._panelObserver.observe(adsorptionPanel, {
                attributes: true,
                attributeFilter: ['class', 'aria-hidden'],
              });
            }

            this.bindMobileWheelScroll();
            this.applyLayoutMode();
            this.syncFromProductVariant(this.dataset.defaultVariantId);
          }

          disconnectedCallback() {
            document.removeEventListener('click', this._onSkuClick, true);
            document.removeEventListener('product-variant:change', this._onVariantChange);
            window.removeEventListener('resize', this._onResize);
            this.desktopMedia.removeEventListener('change', this._onDesktopChange);
            this._panelObserver?.disconnect();
            this.unbindMobileWheelScroll();
            this.removeEventListener('click', this._handleAccordionClick);
            this.removeEventListener('keydown', this._handleAccordionKeydown);
            this.variantTabs.forEach((tab) => {
              tab.removeEventListener('click', this._handleTabClick);
            });
          }

          isDesktopLayout() {
            return this.desktopMedia.matches;
          }

          handleVariantChangeEvent(event) {
            const variantId = event.detail?.variantId;
            if (!variantId) return;

            this.activateVariant(String(variantId));
          }

          handleDesktopChange() {
            this.applyLayoutMode();
            this.activateVariant(this.getCurrentVariantId());
            this.bindMobileWheelScroll();
          }

          handleResize() {
            if (this.isDesktopLayout()) {
              this.updateIndicator();
            }
          }

          bindMobileWheelScroll() {
            this.unbindMobileWheelScroll();
            this._boundWheelEls = [];

            this.querySelectorAll('.product-adsorption-package-content__grid-mobile').forEach((el) => {
              el.addEventListener('wheel', this._onMobileWheel, { passive: false });
              this._boundWheelEls.push(el);
            });
          }

          unbindMobileWheelScroll() {
            this._boundWheelEls?.forEach((el) => {
              el.removeEventListener('wheel', this._onMobileWheel);
            });
            this._boundWheelEls = [];
          }

          handleMobileWheel(event) {
            const el = event.currentTarget;
            if (el.scrollWidth <= el.clientWidth) return;
            if (Math.abs(event.deltaX) >= Math.abs(event.deltaY)) return;

            event.preventDefault();
            el.scrollLeft += event.deltaY;
          }

          applyLayoutMode() {
            if (this.isDesktopLayout()) {
              const activeItem =
                this.accordionItems.find((item) => item.classList.contains('is-active')) || this.accordionItems[0];

              if (activeItem) {
                this.activateVariant(activeItem.dataset.variantId, { forceDesktop: true });
              }

              this.updateIndicator();
              return;
            }

            const activeItem =
              this.accordionItems.find((item) => item.classList.contains('is-active')) ||
              this.accordionItems.find((item) => item.getAttribute('data-active') === 'true') ||
              this.accordionItems[0];

            this.accordionItems.forEach((item) => {
              item.classList.remove('is-active');
              this.setItemActive(item, item === activeItem);
            });
          }

          handleTabClick(event) {
            const tab = event.currentTarget;
            const variantId = tab.dataset.variantId;
            if (!variantId) return;

            this.activateVariant(variantId);
          }

          handleAccordionClick(event) {
            if (this.isDesktopLayout()) return;

            const summary = event.target.closest('.product-adsorption-package-content__accordion-summary');
            if (!summary || !this.contains(summary)) return;

            const item = summary.closest('.product-adsorption-package-content__accordion-item');
            if (!item) return;

            this.toggleAccordionItem(item);
          }

          handleAccordionKeydown(event) {
            if (this.isDesktopLayout()) return;
            if (event.key !== 'Enter' && event.key !== ' ') return;

            const summary = event.target.closest('.product-adsorption-package-content__accordion-summary');
            if (!summary || !this.contains(summary)) return;

            event.preventDefault();

            const item = summary.closest('.product-adsorption-package-content__accordion-item');
            if (!item) return;

            this.toggleAccordionItem(item);
          }

          toggleAccordionItem(item) {
            const isActive = item.getAttribute('data-active') === 'true';

            if (!isActive) {
              this.accordionItems.forEach((otherItem) => {
                if (otherItem !== item) {
                  this.setItemActive(otherItem, false);
                }
              });
              this.activateVariant(item.dataset.variantId, { syncTabs: false });
              return;
            }

            this.setItemActive(item, false);
          }

          setItemActive(item, isActive) {
            item.setAttribute('data-active', isActive ? 'true' : 'false');

            const summary = item.querySelector('.product-adsorption-package-content__accordion-summary');
            if (summary) {
              summary.setAttribute('aria-expanded', isActive ? 'true' : 'false');
            }
          }

          handleExternalVariantChange(event) {
            const multiItem = event.target.closest?.('.main-product-v2-multiattribute__item');
            if (multiItem?.dataset.variantId) {
              this.activateVariant(multiItem.dataset.variantId);
              return;
            }

            const sku = event.target.closest?.('.sku');
            if (!sku) return;

            const variantId = sku.getAttribute('data-id');
            if (!variantId) return;

            this.activateVariant(variantId);
          }

          handlePanelVisibility() {
            const adsorptionPanel = this.closest('.product-tabs-content-v2__panel');
            if (!adsorptionPanel?.classList.contains('product-tabs-content-v2__panel--active')) return;

            const variantId = this.getCurrentVariantId();
            this.activateVariant(variantId);
          }

          getCurrentVariantId() {
            if (this.dataset.activeVariantId) {
              return this.dataset.activeVariantId;
            }

            const activeSku = document.querySelector('choose-products .sku.active-sku');
            return activeSku?.getAttribute('data-id') || this.dataset.defaultVariantId;
          }

          activateVariant(variantId, options = {}) {
            if (!variantId) return;

            this.dataset.activeVariantId = String(variantId);

            const { syncTabs = true, forceDesktop = false } = options;
            const isDesktop = forceDesktop || this.isDesktopLayout();
            let matched = false;

            if (syncTabs) {
              this.variantTabs.forEach((tab) => {
                const isActive = tab.dataset.variantId === String(variantId);
                tab.dataset.active = isActive ? 'true' : 'false';
                if (isActive) matched = true;
              });
            }

            this.accordionItems.forEach((item) => {
              const isActive = item.dataset.variantId === String(variantId);
              item.classList.toggle('is-active', isActive);

              if (isDesktop) {
                if (isActive) matched = true;
                return;
              }

              if (isActive) {
                this.setItemActive(item, true);
                matched = true;
              } else {
                this.setItemActive(item, false);
              }
            });

            if (isDesktop && matched) {
              this.updateIndicator();
            }
          }

          syncFromProductVariant(variantId) {
            if (!variantId) return;
            this.activateVariant(String(variantId));
          }

          updateIndicator() {
            if (!this.variantNav || !this.isDesktopLayout()) return;

            const activeTab = this.variantTabs.find((tab) => tab.dataset.active === 'true');
            if (!activeTab) return;

            const navRect = this.variantNav.getBoundingClientRect();
            const tabRect = activeTab.getBoundingClientRect();

            this.variantNav.style.setProperty('--package-tab-indicator-left', `${tabRect.left - navRect.left}px`);
            this.variantNav.style.setProperty('--package-tab-indicator-width', `${tabRect.width}px`);
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-tabs-content-v2-review"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-adsorption-review-content')) {
    customElements.define(
      'product-adsorption-review-content',
      class ProductAdsorptionReviewContent extends HTMLElement {
        connectedCallback() {
          this._onPanelChange = this.handlePanelChange.bind(this);
          this._observer = new MutationObserver(this._onPanelChange);
          this._observer.observe(this, {
            attributes: true,
            attributeFilter: ['class', 'aria-hidden'],
          });

          this.handlePanelChange();
        }

        disconnectedCallback() {
          this._observer?.disconnect();
          this.reviewsSwiper?.destroy(true, true);
          this.reviewsSwiper = null;
        }

        /** Tab 面板可见时再初始化 Swiper / Trustpilot，避免 display:none 导致不渲染 */
        handlePanelChange() {
          if (this.getAttribute('aria-hidden') === 'true') return;
          if (!this.classList.contains('product-tabs-content-v2__panel--active')) return;

          this.initReviewsSwiper();

          const widget = this.querySelector('.trustpilot-widget');
          if (!widget || widget.dataset.tpLoaded === 'true') return;

          if (window.Trustpilot?.loadFromElement) {
            window.Trustpilot.loadFromElement(widget, true);
            widget.dataset.tpLoaded = 'true';
          }
        }

        initReviewsSwiper() {
          if (this.reviewsSwiper) return;

          if (typeof Swiper === 'undefined') {
            console.error('[product-adsorption-review-content] Swiper is not loaded.');
            return;
          }

          const swiperEl = this.querySelector('.product-adsorption-review-content__reviews-swiper');
          if (!swiperEl) return;

          const prevEl = this.querySelector('.product-adsorption-review-content__review-nav-btn--prev');
          const nextEl = this.querySelector('.product-adsorption-review-content__review-nav-btn--next');
          const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;
          if (slideCount <= 1) return;

          this.reviewsSwiper = new Swiper(swiperEl, {
            slidesPerView: 'auto',
            spaceBetween: 16,
            watchOverflow: true,
            navigation: {
              prevEl,
              nextEl,
            },
            breakpoints: {
              1201: {
                slidesPerView: 3,
                spaceBetween: 24,
              },
              577: {
                slidesPerView: 'auto',
                spaceBetween: 24,
              },
            },
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-tabs-content-v2-spec"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('product-adsorption-spec-content')) {
      customElements.define(
        'product-adsorption-spec-content',
        class ProductAdsorptionSpecContent extends HTMLElement {
          static MOBILE_QUERY = '(max-width: 960px)';

          connectedCallback() {
            this.details = Array.from(this.querySelectorAll('.product-adsorption-spec-content__details'));
            this.mobileMq = window.matchMedia(ProductAdsorptionSpecContent.MOBILE_QUERY);

            this._handleClick = this.handleClick.bind(this);
            this._handleKeydown = this.handleKeydown.bind(this);
            this._onBreakpointChange = this.syncDetailsState.bind(this);

            this.addEventListener('click', this._handleClick);
            this.addEventListener('keydown', this._handleKeydown);
            this.mobileMq.addEventListener('change', this._onBreakpointChange);

            this.syncDetailsState();
          }

          disconnectedCallback() {
            this.removeEventListener('click', this._handleClick);
            this.removeEventListener('keydown', this._handleKeydown);
            this.mobileMq.removeEventListener('change', this._onBreakpointChange);
          }

          isMobileLayout() {
            return this.mobileMq.matches;
          }

          /** 桌面端全部展开；移动端默认只展开第一组 */
          syncDetailsState() {
            this.details.forEach((detail, index) => {
              if (this.isMobileLayout()) {
                this.setItemActive(detail, index === 0);
                return;
              }

              this.setItemActive(detail, true);
            });
          }

          handleClick(event) {
            if (!this.isMobileLayout()) return;

            const summary = event.target.closest('.product-adsorption-spec-content__summary');
            if (!summary || !this.contains(summary)) return;

            const detail = summary.closest('.product-adsorption-spec-content__details');
            if (!detail) return;

            this.toggleItem(detail);
          }

          handleKeydown(event) {
            if (!this.isMobileLayout()) return;
            if (event.key !== 'Enter' && event.key !== ' ') return;

            const summary = event.target.closest('.product-adsorption-spec-content__summary');
            if (!summary || !this.contains(summary)) return;

            event.preventDefault();

            const detail = summary.closest('.product-adsorption-spec-content__details');
            if (!detail) return;

            this.toggleItem(detail);
          }

          toggleItem(detail) {
            const isActive = detail.getAttribute('data-active') === 'true';

            if (!isActive) {
              this.details.forEach((item) => {
                if (item !== detail) {
                  this.setItemActive(item, false);
                }
              });
              this.setItemActive(detail, true);
              return;
            }

            this.setItemActive(detail, false);
          }

          setItemActive(detail, isActive) {
            detail.setAttribute('data-active', isActive ? 'true' : 'false');

            const summary = detail.querySelector('.product-adsorption-spec-content__summary');
            if (summary) {
              summary.setAttribute('aria-expanded', isActive ? 'true' : 'false');
            }
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-tabs-content-v2-user-manual"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-adsorption-user-manual-content')) {
    customElements.define(
      'product-adsorption-user-manual-content',
      class ProductAdsorptionUserManualContent extends HTMLElement {
        connectedCallback() {
          this.downloadButtons = this.querySelectorAll('[data-download-url]');
          this.videoCard = this.querySelector('.product-adsorption-user-manual-content__video-card');
          this.videoTrigger = this.querySelector('.product-adsorption-user-manual-content__video-trigger');
          this.videoIframe = this.querySelector('[data-video-iframe]');
          this.videoClose = this.querySelector('[data-video-close]');

          this.downloadButtons.forEach((button) => {
            button.addEventListener('click', this.handleDownload.bind(this));
          });

          if (this.videoTrigger) {
            this.videoTrigger.addEventListener('click', this.handleVideoPlay.bind(this));
          }

          if (this.videoClose) {
            this.videoClose.addEventListener('click', this.handleVideoClose.bind(this));
          }
        }

        buildEmbedSrc(youtubeId) {
          return `https://www.youtube.com/embed/${youtubeId}?autoplay=1&mute=1&playsinline=1&controls=1&enablejsapi=1&modestbranding=1&rel=0`;
        }

        handleVideoPlay() {
          if (!this.videoCard || !this.videoIframe || !this.videoTrigger) return;

          const youtubeId = this.videoTrigger.dataset.youtubeId;
          if (!youtubeId) return;

          if (!this.videoIframe.src || !this.videoIframe.src.includes('youtube.com/embed/')) {
            this.videoIframe.src = this.buildEmbedSrc(youtubeId);
          } else {
            const currentSrc = this.videoIframe.getAttribute('src') || '';
            if (!currentSrc.includes('autoplay=1')) {
              this.videoIframe.setAttribute('src', `${currentSrc}&autoplay=1&mute=1&playsinline=1&enablejsapi=1`);
            }
          }

          this.videoCard.setAttribute('data-video-state', 'playing');
        }

        handleVideoClose() {
          if (!this.videoCard || !this.videoIframe) return;

          this.videoIframe.setAttribute('src', '');
          this.videoCard.setAttribute('data-video-state', 'poster');
        }

        handleDownload(event) {
          const button = event.currentTarget;
          const downloadUrl = button.getAttribute('data-download-url');
          if (!downloadUrl) return;

          const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
          const filename = (downloadUrl.split('/').pop() || 'download').replace(/\?.*$/, '');

          if (isIOS) {
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.download = filename;
            link.target = '_blank';
            link.rel = 'noopener noreferrer';
            link.click();
            return;
          }

          fetch(downloadUrl)
            .then((response) => response.blob())
            .then((blob) => {
              const blobUrl = window.URL.createObjectURL(blob);
              const link = document.createElement('a');
              link.href = blobUrl;
              link.download = filename;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              window.URL.revokeObjectURL(blobUrl);
            })
            .catch(() => {
              window.open(downloadUrl, '_blank', 'noopener,noreferrer');
            });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["link-nav"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('link-nav')) {
      customElements.define(
        'link-nav',
        class LinkNav extends HTMLElement {
          constructor() {
            super();
          }

          connectedCallback() {
            const placeholder = this.querySelector('.link-nav__badge-placeholder');
            const textWrap = this.querySelector('.link-nav__text-wrap');
            const link = this.querySelector('.link-nav__link');
            if (placeholder && textWrap && link && placeholder.children.length > 0) {
              const badge = placeholder.children[0];
              const navLayout = this.closest('.nav-layout');
              if (!navLayout) return;

              textWrap.appendChild(badge);

              this._updateBadgePosition = () => {
                requestAnimationFrame(() => {
                  const layoutRect = navLayout.getBoundingClientRect();
                  const linkRect = link.getBoundingClientRect();
                  badge.style.top = '10px';
                  badge.style.left = linkRect.left - layoutRect.left + linkRect.width / 2 + 'px';
                });
              };

              this._updateBadgePosition();

              this._badgeResizeObserver = new ResizeObserver(this._updateBadgePosition);
              this._badgeResizeObserver.observe(link);

              this._navScroller = this.closest('.nav-layout__list');
              if (this._navScroller) {
                this._navScroller.addEventListener('scroll', this._updateBadgePosition, { passive: true });
              }
            }
          }

          disconnectedCallback() {
            if (this._badgeResizeObserver) {
              this._badgeResizeObserver.disconnect();
              this._badgeResizeObserver = null;
            }
            if (this._navScroller && this._updateBadgePosition) {
              this._navScroller.removeEventListener('scroll', this._updateBadgePosition);
              this._navScroller = null;
            }
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["menu-nav"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('menu-nav')) return;

    customElements.define(
      'menu-nav',
      class MenuNav extends HTMLElement {
        connectedCallback() {
          this._blockId = this.querySelector('[data-mobile-menu-content]')?.getAttribute('data-block-id');
          this._mobileMenuSource = this.querySelector('[data-mobile-menu-content]');
          this._onMobileMenuSectionClick = this._onMobileMenuSectionClick.bind(this);

          if (this._mobileMenuSource) {
            this._mobileMenuSource.addEventListener('click', this._onMobileMenuSectionClick);
            this._observeMobileMenuSource();
          }

          this._scheduleInitMenuSections();
        }

        disconnectedCallback() {
          if (this._mobileMenuSource) {
            this._mobileMenuSource.removeEventListener('click', this._onMobileMenuSectionClick);
          }
          if (this._mobileSourceObserver) {
            this._mobileSourceObserver.disconnect();
            this._mobileSourceObserver = null;
          }
        }

        _getMobileMenuSource() {
          if (this._mobileMenuSource && this._mobileMenuSource.isConnected) {
            return this._mobileMenuSource;
          }

          if (!this._blockId) return null;

          const escaped =
            typeof CSS !== 'undefined' && typeof CSS.escape === 'function'
              ? CSS.escape(this._blockId)
              : String(this._blockId).replace(/\\/g, '\\\\').replace(/"/g, '\\"');

          return document.querySelector(
            `.header-v2-mobile-nav-panel [data-mobile-menu-content][data-block-id="${escaped}"]`
          );
        }

        _scheduleInitMenuSections() {
          const run = () => this._initMobileMenuSectionsExpanded();
          run();
          requestAnimationFrame(run);
          window.setTimeout(run, 0);
        }

        _observeMobileMenuSource() {
          const source = this._mobileMenuSource;
          if (!source) return;

          this._mobileSourceObserver = new MutationObserver(() => {
            if (source.classList.contains('is-open')) {
              this._scheduleInitMenuSections();
            }
          });
          this._mobileSourceObserver.observe(source, {
            attributes: true,
            attributeFilter: ['class'],
          });
        }

        _initMobileMenuSectionsExpanded() {
          const source = this._getMobileMenuSource();
          if (!source) return;

          const sections = source.querySelectorAll('.header-v2-mobile-menu__section');
          let firstExpandableHandled = false;

          sections.forEach((section) => {
            const panel = section.querySelector('.header-v2-mobile-menu__panel');
            const heading = section.querySelector('.header-v2-mobile-menu__heading');
            if (!panel || !heading) return;

            const expanded = !firstExpandableHandled;
            if (expanded) {
              firstExpandableHandled = true;
            }

            section.classList.toggle('is-expanded', expanded);
            heading.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          });
        }

        _onMobileMenuSectionClick(event) {
          const heading = event.target.closest('.header-v2-mobile-menu__heading');
          if (!heading || heading.classList.contains('header-v2-mobile-menu__heading--link')) return;

          const section = heading.closest('.header-v2-mobile-menu__section');
          if (!section || !section.querySelector('.header-v2-mobile-menu__panel')) return;

          event.preventDefault();

          const expanded = section.classList.toggle('is-expanded');
          heading.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        }
      }
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["public-benefit-activity-item"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('public-benefit-activity-detail')) {
      customElements.define(
        'public-benefit-activity-detail',
        class PublicBenefitActivityDetail extends HTMLElement {
          constructor() {
            super();
            this.mainImage = null;
            this.currentWidth = 100;
            this.lastScrollTop = 0;
            this._boundHandleScroll = this.handleScroll.bind(this);
          }

          connectedCallback() {
            this.mainImage = this.querySelector('.public-benefit-activity-detail__main-image');
            if (this.mainImage) {
              this.addEventListener('scroll', this._boundHandleScroll);
            }
          }

          disconnectedCallback() {
            if (this.mainImage) {
              this.removeEventListener('scroll', this._boundHandleScroll);
            }
          }

          handleScroll() {
            if (!this.mainImage) return;
            const scrollTop = this.scrollTop;

            if (scrollTop === 0) {
              this.mainImage.style.transition = 'width 0.3s ease-out';
              this.mainImage.style.width = '100%';
              this.currentWidth = 100;
              this.lastScrollTop = 0;
              return;
            }

            const scrollChange = scrollTop - this.lastScrollTop;
            this.lastScrollTop = scrollTop;

            let newWidth = this.currentWidth - scrollChange / 10;
            newWidth = Math.max(60, Math.min(100, newWidth));
            newWidth = Math.round(newWidth);

            if (newWidth !== this.currentWidth) {
              this.currentWidth = newWidth;
              this.mainImage.style.transition = 'width 0.1s ease-out';
              requestAnimationFrame(() => {
                this.mainImage.style.width = newWidth + '%';
              });
            }
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["tailgate-purchase-equipment"] && !Shopify.designMode) return;
  try {
    $(function () {
    // 在这里编写需要在文档加载完成后执行的代码
    if (!customElements.get('tailgate-purchase-equipment')) {
      customElements.define(
        'tailgate-purchase-equipment',
        class tailgatePurchaseEquipment extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
          }
          init() {
            this._mySwiper = this.querySelector('.tailgate-purchase-equipment__list_swiper');
            this._handleResize = this._handleResize.bind(this);
            window.addEventListener('resize', this._handleResize);
            this._handleResize();
          }
          _handleResize() {
            if (!this._mySwiper) return;
            if (window.innerWidth <= 960) {
              if (!this._swiper) {
                this._swiper = new Swiper(this._mySwiper, {
                  slidesPerView: 'auto',
                  spaceBetween: 12,
                  scrollbar: {
                    el: this._mySwiper.querySelector('.swiper-scrollbar'),
                    draggable: true,
                  },
                });
              }
            } else {
              if (this._swiper) {
                this._swiper.destroy(true, true);
                this._swiper = null;
              }
            }
          }
          disconnectedCallback() {
            window.removeEventListener('resize', this._handleResize);
            if (this._swiper) {
              this._swiper.destroy(true, true);
              this._swiper = null;
            }
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

})();
